// Pagination constants
export const DEFAULT_PAGE_LIMIT = 50;
export const MAX_JOBS_LIMIT = 1000;
export const DEFAULT_LOGS_LIMIT = 100;
export const MAX_LOGS_LIMIT = 1000;

// Enums
export enum JobType {
  ARENA_CREATION = "ARENA_CREATION",
  ARENA_LOCK = "ARENA_LOCK",
  ARENA_UNLOCK = "ARENA_UNLOCK",
  CRM_IMPORT = "CRM_IMPORT",
}

export enum JobStatus {
  CREATED = "CREATED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export enum EffectiveStatus {
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  CREATED = "CREATED",
}

export enum LogLevel {
  INFO = "INFO",
  ERROR = "ERROR",
  WARNING = "WARNING",
  DEBUG = "DEBUG",
  WARN = "WARN",
  CRITICAL = "CRITICAL",
}
